import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { Gavel } from "lucide-react";

export const Route = createFileRoute("/_authenticated/bids")({
  head: () => ({ meta: [{ title: "Bids and Offers — Want To Buy" }] }),
  component: BidsPage,
});

function BidsPage() {
  return (
    <AppShell>
      <div className="mb-6">
        <h1 className="font-display text-3xl font-bold flex items-center gap-2">
          <Gavel className="h-7 w-7 text-primary" /> Bids and Offers
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Offers received on your buy orders, and offers you've submitted as a seller.</p>
      </div>

      <div className="panel p-10 text-center text-sm text-muted-foreground">
        <p>No bids or offers yet.</p>
        <p className="mt-2">
          Offers received on your buy orders appear here, and your submitted seller offers show their status.{" "}
          <Link to="/" className="text-primary hover:underline">Browse open buy orders</Link> to submit your first offer, or{" "}
          <Link to="/create-order" className="text-primary hover:underline">post a buy order</Link> to receive competing offers.
        </p>
      </div>
    </AppShell>
  );
}
